import PropTypes from 'prop-types';
import React from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { authProtectedRoutes, publicRoutes } from './routes';
import NonAuthLayout from './components/NonAuthLayout';
// Import scss
import './assets/scss/theme.scss';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { PrivateRoute } from './lib/PrivateRoute';

import { useAuthStore } from './zustand-store/auth.store';
import './index.css';
import NotFound from './pages/NotFound';
import { JoyrideProvider } from './JoyrideContext';
import { emit } from './utils/trackingBridge';
import { socket } from './helpers/socket';
import { redirectToLoginOnSessionExpiry } from './axios/axiosConfig';
//import { SEAMLESSSLOT_FEATURES } from '@seamlessslot/shared';

// import ReactGA from "react-ga4";
// Activating fake backend
//fakeBackend();

// const firebaseConfig = {
//   apiKey: import.meta.env.VITE_APP_APIKEY,
//   authDomain: import.meta.env.VITE_APP_AUTHDOMAIN,
//   databaseURL: import.meta.env.VITE_APP_DATABASEURL,
//   projectId: import.meta.env.VITE_APP_PROJECTID,
//   storageBucket: import.meta.env.VITE_APP_STORAGEBUCKET,
//   messagingSenderId: import.meta.env.VITE_APP_MESSAGINGSENDERID,
//   appId: import.meta.env.VITE_APP_APPID,
//   measurementId: import.meta.env.VITE_APP_MEASUREMENTID,
// };

// init firebase backend
// initFirebaseBackend(firebaseConfig)
// ReactGA.initialize("G-R7JF4L4FK9", {
//   gaOptions: {
//     cookieDomain: "auto", // Automatically handles subdomains
//   },
// });
const App = () => {
  // const selectLayoutState = (state) => state.Layout;
  // const refreshAllTheToken = useAuthStore((state) => state.refreshAllTheToken);
  const refreshAllTheToken = useAuthStore((state) => state.refreshAllTheToken);
  const accessToken = useAuthStore((state) => state.accessToken);
  const location = useLocation();
  const navigate = useNavigate();

  // const LayoutProperties = createSelector(selectLayoutState, (layout) => ({
  //   layoutType: layout.layoutType
  // }));

  // const { layoutType } = useSelector(LayoutProperties);

  // function getLayout(layoutType) {
  //   let layoutCls = VerticalLayout;
  //   switch (layoutType) {
  //     case 'horizontal':
  //       layoutCls = HorizontalLayout;
  //       break;
  //     default:
  //       layoutCls = VerticalLayout;
  //       break;
  //   }
  //   return layoutCls;
  // }

  //const Layout = VerticalLayout;

  React.useEffect(() => {
    refreshAllTheToken();
    localStorage.setItem('path', location.pathname);
  }, []);

  // The backend broadcasts SESSION_INVOKED to every client when a session is revoked or
  // logged out remotely; only the client holding that session logs out.
  React.useEffect(() => {
    const onSessionInvoked = (payload) => {
      const mySessionId = useAuthStore.getState().sessionId;
      if (payload?.sessionId && mySessionId && payload.sessionId === mySessionId) {
        redirectToLoginOnSessionExpiry('Your session was ended. Please log in again.');
      }
    };
    socket.on('SESSION_INVOKED', onSessionInvoked);
    return () => {
      socket.off('SESSION_INVOKED', onSessionInvoked);
    };
  }, []);

  React.useEffect(() => {
    emit('virtual_pageview', { page_path: location.pathname, page_title: document.title });
  }, [location.pathname]);

  React.useEffect(() => {
    const validPaths = [
      '/callback',
      '/termsandconditions',
      '/appointment',
      '/patientInfo',
      '/summary',
      '/termsandconditions',
      '/forgotpassword',
      '/register',
      '/google/callback',
      '/microsoft/callback',
      '/verify',
      '/verifyInvite',
      'signup',
      '/bookdemo',
      '/contactus',
      '/appointment-notfound',
      '/choose-location',
      '/book'
    ];
    if (accessToken && !validPaths.includes(localStorage.getItem('path'))) {
      navigate(localStorage.getItem('path'));
    }
  }, [accessToken]);

  return (
    <React.Fragment>
      <ToastContainer />
      {/* {SEAMLESSSLOT_FEATURES.map((feature) => {
        return (
          <>
            <p>{feature.name}</p>
            <p>{feature.id}</p>
          </>
        );
      })} */}
   
        <Routes>
          {publicRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={<NonAuthLayout>{route.component}</NonAuthLayout>}
              key={idx}
              exact={true}
            />
          ))}

          {authProtectedRoutes.map((route, idx) => {
            return (
              <Route
                path={route.path}
                element={<PrivateRoute roles={route.role}>{route.component}</PrivateRoute>}
                key={idx}
                exact={true}
              />
            );
          })}
          <Route path="*" element={<NotFound />} />
        </Routes>
    </React.Fragment>
  );
};

App.propTypes = {
  layout: PropTypes.any
};

const mapStateToProps = (state) => {
  return {
    layout: state.Layout
  };
};

export default connect(mapStateToProps, null)(App);
